export const diagnosticDicionaryError: Record<string, string> = {
  'diagnostic.errors.workorder_auth_item_empty':
    'Poderá ser criado um diagnóstico somente quando tiver peças.',
};
